import envVariables from "../data/envVariables";

export const portalApiBase = `${envVariables.apiEndpoint}/api/portal`;

export const authConfig = (token) => ({
    headers: { "Content-Type": "application/json", ...(token ? { Authorization: `Bearer ${token}` } : {}) },
});

// Portal endpoints can report application errors inside an HTTP-success response.
export const checkedData = (response, message = "Portal request failed") => {
    const data = response.data;
    if (
        data?.success === false ||
        data?.error ||
        data?.status === "error" ||
        data?.data?.some?.((row) => row.status === "error")
    ) {
        throw new Error(message);
    }
    return data;
};
